var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.1875C12.9141 17.1875 13.6875 17.9609 13.6875 18.875C13.6875 19.8242 12.9141 20.5625 12 20.5625C11.0508 20.5625 10.3125 19.8242 10.3125 18.875C10.3125 17.9609 11.0508 17.1875 12 17.1875ZM12 11.5625C12.9141 11.5625 13.6875 12.3359 13.6875 13.25C13.6875 14.1992 12.9141 14.9375 12 14.9375C11.0508 14.9375 10.3125 14.1992 10.3125 13.25C10.3125 12.3359 11.0508 11.5625 12 11.5625ZM12 9.3125C11.0508 9.3125 10.3125 8.57422 10.3125 7.625C10.3125 6.71094 11.0508 5.9375 12 5.9375C12.9141 5.9375 13.6875 6.71094 13.6875 7.625C13.6875 8.57422 12.9141 9.3125 12 9.3125Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.332381a25a97e3329321a21c36b363d5.svg";
export { ForwardRef as ReactComponent };